import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import EditForm from '../../../../features/components/Forms/EditForm'
import DailyRemainingBudgetFields from '../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/FormFields/DailyRemainingBudgetFields'

import { usePurifiedFormik } from '../../../../hooks/formHooks/usePurifiedFormik'

import { selectedGoogleAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import {
  campaignUpdateErrorSelector,
  campaignUpdateIsLoadingSelector,
  campaignWasUpdatedSelector
} from '../../../../modules/selectors/campaigns'
import { clearUpdateCampaign, updateCampaign } from '../../../../modules/actions/campaigns'

import { AMOUNT_MICROS, BUDGET_DAILY, CAMPAIGN_BUDGET } from '../../../Multiplatform/CampaignForms/fields'
import { GOOGLE_PLATFORM } from '../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'
import { getValidationSchema } from './validation'

const BudgetDailySectionForm = ({
  editItemData: campaign,
  budgetDaily,
  remainingBudget,
  updateOptions,
  title,
  ...formProps
}) => {
  const dispatch = useDispatch()

  const campaignWasUpdated = useSelector(campaignWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const handleSubmit = useCallback(
    values => {
      const updateCampaignData = {
        account: selectedAdAccountId,
        [CAMPAIGN_BUDGET]: {
          [AMOUNT_MICROS]: values[BUDGET_DAILY]
        },
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        }
      }

      dispatch(updateCampaign(updateCampaignData, campaign.id, GOOGLE_PLATFORM, updateOptions))
    },
    [dispatch, campaign.id, title, selectedAdAccountId, updateOptions]
  )

  const initialValues = useMemo(
    () => ({
      [BUDGET_DAILY]: String(budgetDaily) || ''
    }),
    [budgetDaily]
  )

  const formik = useFormik({
    initialValues,
    validationSchema: getValidationSchema({ remainingBudget, campaign }),
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdateCampaign = useCallback(() => {
    dispatch(clearUpdateCampaign())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={campaignWasUpdated}
      clearEditItem={handleClearUpdateCampaign}
      errorSelector={campaignUpdateErrorSelector}
      isLoadingSelector={campaignUpdateIsLoadingSelector}
      {...formProps}
    >
      <DailyRemainingBudgetFields
        formik={formik}
        remainingBudget={remainingBudget}
        startDate={campaign.date_start}
        endDate={campaign.date_stop}
        initialCampaignBudgetDaily={campaign?.[BUDGET_DAILY]}
      />
    </EditForm>
  )
}

export default BudgetDailySectionForm
